import './MenuLabel.css';

export function MenuLabel({ children }: React.PropsWithChildren) {
    return <label className='label'>{children}</label>;
}
